module.exports={
  "credits": "<p class=\"credit-text\">Designed and developed by Alyson Hurt and Brent Jones, building on previous work by Thomas Wilburn, Audrey Carlsen, Hilary Fung and Shajia Abidi.</p>\n<p class=\"credit-text\">Edited by Dana Farrington, Heidi Glenn, Megan Pratz and Benjamin Swasey</p>",
  "P": "President",
  "S": "U.S. Senate",
  "H": "U.S. House",
  "G": "Governor",
  "I": "Ballot measure",
  "race-S": "Special (Primary)",
  "race-GS": "Special (General)",
  "race-GRS": "Special (General: Runoff)",
  "race-G": "General",
  "race-GR": "General: Runoff",
  "race-R": "Runoff",
  "race-RS": "Special (Primary: Runoff)",
  "race-I": "Ballot measure",
  "AL": "Alabama",
  "AK": "Alaska",
  "AZ": "Arizona",
  "AR": "Arkansas",
  "CA": "California",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DC": "District of Columbia",
  "DE": "Delaware",
  "FL": "Florida",
  "GA": "Georgia",
  "GU": "Guam",
  "HI": "Hawaii",
  "ID": "Idaho",
  "IL": "Illinois",
  "IN": "Indiana",
  "IA": "Iowa",
  "KS": "Kansas",
  "KY": "Kentucky",
  "LA": "Louisiana",
  "ME": "Maine",
  "MD": "Maryland",
  "MA": "Massachusetts",
  "MI": "Michigan",
  "FM": "Micronesia",
  "MN": "Minnesota",
  "MS": "Mississippi",
  "MO": "Missouri",
  "MT": "Montana",
  "NE": "Nebraska",
  "NV": "Nevada",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NY": "New York",
  "NC": "North Carolina",
  "ND": "North Dakota",
  "OH": "Ohio",
  "OK": "Oklahoma",
  "OR": "Oregon",
  "PW": "Palau",
  "PA": "Pennsylvania",
  "PR": "Puerto Rico",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "TX": "Texas",
  "UT": "Utah",
  "VT": "Vermont",
  "VA": "Virginia",
  "WA": "Washington",
  "WV": "West Virginia",
  "WI": "Wisconsin",
  "WY": "Wyoming",
  "AL-AP": "Ala.",
  "AK-AP": "Alaska",
  "AZ-AP": "Ariz.",
  "AR-AP": "Ark.",
  "CA-AP": "Calif.",
  "CO-AP": "Colo.",
  "CT-AP": "Conn.",
  "DE-AP": "Del.",
  "DC-AP": "D.C.",
  "FL-AP": "Fla.",
  "GA-AP": "Ga.",
  "HI-AP": "Hawaii",
  "ID-AP": "Idaho",
  "IL-AP": "Ill.",
  "IN-AP": "Ind.",
  "IA-AP": "Iowa",
  "KS-AP": "Kan.",
  "KY-AP": "Ky.",
  "LA-AP": "La.",
  "ME-AP": "Maine",
  "MD-AP": "Md.",
  "MA-AP": "Mass.",
  "MI-AP": "Mich.",
  "MN-AP": "Minn.",
  "MS-AP": "Miss.",
  "MO-AP": "Mo.",
  "MT-AP": "Mont.",
  "NE-AP": "Neb.",
  "NV-AP": "Nev.",
  "NH-AP": "N.H.",
  "NJ-AP": "N.J.",
  "NM-AP": "N.M.",
  "NY-AP": "N.Y.",
  "NC-AP": "N.C.",
  "ND-AP": "N.D.",
  "OH-AP": "Ohio",
  "OK-AP": "Okla.",
  "OR-AP": "Ore.",
  "PA-AP": "Pa.",
  "RI-AP": "R.I.",
  "SC-AP": "S.C.",
  "SD-AP": "S.D.",
  "TN-AP": "Tenn.",
  "TX-AP": "Texas",
  "UT-AP": "Utah",
  "VT-AP": "Vt.",
  "VA-AP": "Va.",
  "WA-AP": "Wash.",
  "WV-AP": "W.Va.",
  "WI-AP": "Wis.",
  "WY-AP": "Wyo.",
  "PR-AP": "P.R.",
  "VI-AP": "V.I.",
  "GU-AP": "Guam",
  "MP-AP": "M.P.",
  "AS-AP": "A.S."
}